import type { Component } from "vue";

import { BuildIcon, ChatIcon, ProjectIcon, TaskIcon } from "~/icons";
import { CommandId, Key, ViewMode } from "~/shared/enums";

export type ViewModeTab = {
  value: ViewMode;
  title: string;
  icon: Component;
  aliases: string[];
  earlyAccessOnly?: boolean;
};

export const VIEW_MODE_TABS: ViewModeTab[] = [
  {
    value: ViewMode.PROJECTS,
    title: "Projects",
    icon: ProjectIcon,
    aliases: ["projects"],
  },
  {
    value: ViewMode.AGENTS,
    title: "Tasks",
    icon: TaskIcon,
    aliases: ["tasks", "agents"],
    earlyAccessOnly: true,
  },
  {
    value: ViewMode.BUILD,
    title: "Build",
    icon: BuildIcon,
    aliases: ["build"],
  },
  {
    value: ViewMode.CHATS,
    title: "Chats",
    icon: ChatIcon,
    aliases: ["chats"],
  },
];

export const VIEW_MODE_TAB_COMMAND_IDS = [
  CommandId.SWITCH_VIEW_MODE_TO_TAB_1,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_2,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_3,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_4,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_5,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_6,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_7,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_8,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_9,
  CommandId.SWITCH_VIEW_MODE_TO_TAB_10,
];

export const VIEW_MODE_DIGIT_KEYS = [
  Key.Digit1,
  Key.Digit2,
  Key.Digit3,
  Key.Digit4,
  Key.Digit5,
  Key.Digit6,
  Key.Digit7,
  Key.Digit8,
  Key.Digit9,
  Key.Digit0,
];

export const VIEW_MODE_TO_DEFAULT_ROUTE_NAME: Record<ViewMode, string> = {
  [ViewMode.PROJECTS]: "home",
  [ViewMode.AGENTS]: "task",
  [ViewMode.BUILD]: "task",
  [ViewMode.CHATS]: "chat",
};

export const getAvailableViewModeTabs = (showEarlyAccess: boolean): ViewModeTab[] =>
  VIEW_MODE_TABS.filter((tab) => showEarlyAccess || !tab.earlyAccessOnly);
